import './context/logger.mjs';
import './context/loggerBoundary.mjs';
import './context/eventPropertyBoundary.mjs';
import { Click } from './components/Click.mjs';
import ViewV2 from './components/View.mjs';
import ImpressionV2 from './components/Impression.mjs';

const EventLogger = { Click, View: ViewV2, Impression: ImpressionV2 };

export { EventLogger };
//# sourceMappingURL=EventLogger.mjs.map
